<script>
import InputRadio from '../../atoms/inputlib/components/InputRadio'
import Dropdown from '@/components/atoms/Dropdown'
import Badge from '@/components/molecules/Badge'
import { mapGetters } from 'vuex'
import RadioLine from '@/components/molecules/input/RadioLine'
import Box from '@/components/atoms/Box'
export default {
    name: 'RadioAddress',
    components: { RadioLine, Badge, Dropdown, InputRadio, Box },
    props: {
        address: null,
        value: null,
        hintText: null,
        required: Boolean,
        disabled: Boolean,
        readonly: Boolean,
        allowEmpty: Boolean,
        hideAllowance: Boolean,
        editable: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        ...mapGetters({
            activeRestaurant: 'active/restaurant',
            expenseRules: 'expenseRules',
            allowance: 'allowance',
        }),
        cart() {
            return this.$cart
        },
        isCompany() {
            return this.address.is_company_address
        },
        addressIcon() {
            return `fa-solid ${this.isCompany ? 'fa-briefcase' : 'fa-location-arrow'}`
        },
        availableRules() {
            return this.expenseRules
                .filter((rule) => (rule.only_for_company_address ? this.isCompany : true))
                .map((rule) => {
                    rule.active = Boolean(
                        (this.$cart.calculation.usable_expense_rules || []).find(
                            (uRule) => uRule.id === rule.id
                        )
                    )
                    return rule
                })
        },
        isLoggedIn() {
            return this.$user.isLoggedIn
        },
        active() {
            return this.value === this.address.id
        },
    },
    methods: {
        onInput(val) {
            this.$emit('input', val)
        },
        edit() {
            this.$emit('edit')
        },
    },
}
</script>

<template lang="pug">
radio-line(
    :value="value" 
    @input="onInput" 
    :data="address.id" 
    :hint-text="hintText" 
    :required="required" 
    :disabled="disabled"
    :readonly="readonly" 
    :allow-empty="allowEmpty"  
    :class="{'cursor-help': disabled}"  
    reverse)
    .row.w-100(v-tooltip.hover.top.html="disabled ? $t('details.disabled_location') : undefined")
        .col
            .d-flex.align-items-center.line-1.mb-1
                icon.font-size-micro.text-99.mr-3(:icon="addressIcon")
                span.font-weight-semibold.font-size-base.text-26.text-ellipsis {{ address.name }}
            .font-size-md.line-1.text-73(v-if="address")
                template(v-if="address.street") {{address.street}}
                template(v-if="address.house_number") ,&nbsp;{{address.house_number}}
                template(v-if="address.floor_number") ,&nbsp;{{address.floor_number}}
                template(v-if="address.door_number") ,&nbsp;{{address.door_number}}
                template(v-if="address.bell_number") ,&nbsp;{{address.bell_number}}
                template(v-if="address.sub_address") ,&nbsp;{{address.sub_address}}
                br
                template(v-if="address.town") {{address.town}}
                template(v-if="address.zip_code") ,&nbsp;{{address.zip_code}}
                br
                template(v-if="address.phone") {{address.phone}}
        .col-auto.d-flex.align-items-center(v-if="editable || disabled")
            button.btn.btn-transparent.btn-icon.mr-2(v-if="editable && !disabled" @click="edit")
                icon(icon="fa-solid fa-pen")
            icon.text-info(
                v-if="disabled"
                icon="fa-solid fa-info-circle"
                size="lg")
    template(v-slot:extend v-if="!hideAllowance && isLoggedIn")
        box.pl-4.pr-7.hover-bg-f3(v-if="availableRules && availableRules.length" slim)
            template(v-slot:header)
                icon.mr-4.text-primary(icon="fa-solid fa-wallet")
                | {{$t('details.allowance_available')}}
            .pl-4.pb-4
                .d-flex.justify-content-between.text-wrap.py-2(
                    v-for="(allowance, index) in availableRules"
                    :key="`${address}-rule-${index}`"
                    :class="{'border-top': index, 'pb-4': index + 1 === availableRules.length}")
                    .font-weight-semibold.text-break.text-73(:class="{'text-73': !allowance.active && activeRestaurant.id}") {{ allowance.name }}
                        small.ml-2(v-if="allowance.active && activeRestaurant.id") {{$t('details.allowance_available_at_time')}}
                    span.text-73.ml-4 {{ allowance.budget | toCurrency(allowance.locale, allowance.currency_code) }}
                .alert.alert-light-info.mb-4.font-weight-semibold.text-center
                    icon.mr-2(icon="fa-solid fa-exclamation-triangle")
                    | {{$t('details.allowance_select_available_at_checkout') }}
            
                   


</template>
